export default {
  'seivice.orderResponse': 'Respuesta al pedido',
  'seivice.material': 'El material',
  'seivice.warehouse': 'Almacén',
  'seivice.profAtersalesTeam': 'Equipo post-venta profesional'
}
